import { React, useState, useEffect, useRef } from "react";
import { Header } from "../../../components/common/Header.js";
import { SideBar } from "../../../features/SideBar/SideBar.js";
import { useParams } from "react-router-dom";
//Child Components
import { InfoShowcase } from "../../../features/MovieShowcase/InfoShowcase.js";
import Breadcrumb from "../../../components/common/BreadCrumb.js";
import { SocialBar } from "../../../features/SocialBar/SocialBar.js";
import { WatchShowcase } from "../../../features/MovieShowcase/WatchShowcase.js";
import { MediaShowcase } from "../../../features/MovieShowcase/MediaShowcase.js";
import { MovieTagCarousel } from "../../../features/MovieTag/MovieTagCarousel.js";
import { SeasonShowcase } from "../../../features/TvShowcase/SeasonShowcase.js";
//Import API Test below
import { get_detail } from "../../../api/getMovie.js";
import { extractMovData } from "../../../utility/utility.js";
//Redux
import { useDispatch, useSelector } from "react-redux";
import { getDetail } from "../DetailSlice.js";
//Utility
import { extractDetailData } from "../../../utility/utility.js";
import { CollectionShowCase } from "../../../features/MovieShowcase/CollectionShowcase.js";
//Style
import "../DetailsPage.css"; 

export const TvDetailPage = () => {
  const sampleId = 531428;
  const { tvId } = useParams();

  let [detailData, setDetailData] = useState(null);

  //Get Config
  let apiUtility = useSelector((state) => state.apiUtility.apiUtility);
  let { langConfig, tvGenreList } = apiUtility;

  //Handle API Call
  const dispatch = useDispatch();
  let detailDataList = useSelector((state) => state.detail);

  useEffect(() => {
    if (!detailDataList.detailList["tvList"][tvId]) {
      if (detailData) {
        setDetailData(null); //MidAutumn
      }
      dispatch(getDetail({ id: tvId, type: "tv" })).then((res) =>
        setDetailData(res.payload),
      );
    } else {
      setDetailData(detailDataList.detailList.tvList[tvId]);
    }
  }, [tvId]);

  if (detailDataList.detailListLoading || !detailData) {
    return (
      <div className="loading_site">
        <h3>Loading details ... </h3>
      </div>
    );
  } else if (detailDataList.detailListError) {
    return <h3>Error 404</h3>;
  }

  //Custom BreadCrumb Tabs
  const styleBreadCrumb = {
    marginLeft: "calc(400vw/30)",
    marginRight: "calc(200vw/30)",
  };
  function customPathBreadCrumb(tvProps) {
    let tvName = tvProps.title;
    return [{ label: tvName, url: `/details/tv/${tvId}` }];
  }

  return (
    <>
      <div className="tv-detail-page">
        <Header />

        <div className="mov_details_page_content_wrapper">
          <div className="ep_page_info_wrapper">
            <div className="ep_page breadcrumb_wrapper" style={styleBreadCrumb}>
              <Breadcrumb
                paths={customPathBreadCrumb(
                  detailDataList.detailList.tvList[tvId],
                )}
              />
            </div>
            <InfoShowcase
              detailData={detailData}
              langConfig={langConfig}
              genreList={tvGenreList}
            />
          </div>
          <WatchShowcase detailData={detailData} type="tv" season="1" episode="1" />

          <SeasonShowcase
            detailData={detailData.seasons}
            tvId={tvId}
            title={detailData.title}
          />

          <MediaShowcase detailData={detailData} />
          <div className="mov_details_page recommendation_carousel">
            <div className="recommendation_carousel carousel_title">
              Recommendations
            </div>
            <MovieTagCarousel
              movieItems={detailData["recommendation"]}
              isHoverEnable={true}
              isGrid={true}
              isDefaultSmall={true}
              movieType="tv"
            />
          </div>
        </div>
      </div>
      <SideBar />
    </>
  );
};;
